import { configureStore } from '@reduxjs/toolkit'
import { thunk } from 'redux-thunk';
import logger from 'redux-logger'
import searchReducer from "./reducers/search-reducer";
import settingsReducer from "./reducers/settings-reducer";

export const store = configureStore({
    reducer: {
        search: searchReducer,
        settings: settingsReducer
    },
    middleware: (getDefaultMiddleware) => {
        const defaultMiddleware = getDefaultMiddleware()
        return defaultMiddleware.concat([thunk, logger])
    },
})

export const searchSelector = (state) => {
    const { type, rank } = state.settings
    if ((type && type.length === 1) || rank > 0) {
        const filtered = state.search.results
            .filter((item) => type.length !== 1 || item['type'] === type[0])
            .filter((item) => rank === 0 || !item['rank'] || item['rank'] >= rank)
        return {...state.search, results: filtered}
    } else {
        return state.search
    }
}

export const settingsSelector = (state) => state.settings
